import { Route, Routes } from "react-router-dom";
import Home from "pages/Home";
import Projects from "pages/Projects";
import Tools from "pages/Tools";
import Contact from "pages/Contact";
import ProjectDetails from "pages/ProjectDetails";
import ToolDetails from "pages/ToolDetails";
import NotFound from "pages/NotFound";
import Summary from "features/summary";
import Testimonial from "features/testimonial";

const RoutesConfig = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />}>
        <Route
          index
          element={
            <>
              <Summary />
              <Projects />
              <Tools />
              <Testimonial />
            </>
          }
        />
        <Route path="projects" element={<Projects />} />
        <Route path="tools" element={<Tools />} />
        <Route path="experience" element={<Testimonial />} />
        <Route path="contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="projects/:projectName" element={<ProjectDetails />} />
      <Route path="tools/:toolName" element={<ToolDetails />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default RoutesConfig;
